export default {
  methods: {
    confirmDialog(title, desc, callback, y, n) {
      this.$confirm(desc, title, {
        confirmButtonText: y || '确定',
        cancelButtonText: n || '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(callback).catch(() => {})
    }
  }
}
